
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Checkbox, Input, Select } from 'antd';
import axios from 'axios';
import { orders_uri, products_uri } from '../../../utils/url';
import {toast} from 'react-toastify';
import { LEASING_TYPES, PRICE_TYPE } from '../../../utils/types';

const OrderCreate = () => {
    const [selectedItems, setSelectedItems] = useState();
    const [selectedItems1, setSelectedItems1] = useState();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [price, setPrice] = useState([]);
    const [prodcode, setProdcode] = useState([]);
    const [load, setLoad] = useState(false);
    const [datas, setDatas] = useState({ depo_and_phone:'', too:'', leasing: LEASING_TYPES.N, price_id:1 });

    const nav = () => {
        navigate(-1);
    }

    const Get = async() => {
        try{
            const res = await axios.get(products_uri+'/get')
            setData(res.data);
        }catch(err){
            console.log(err);
        }
    }

    const GetPrices = async(e) => {
        try{
            const res = await axios.get(products_uri+`/price?id=${e}`);
            setPrice(res.data);
        }catch(err){
            console.log(err);
        }
    }

    const GetProductCode = async (value) => {
        const encodedValue = encodeURIComponent(value);
        try{
            const res = await axios.get(products_uri+'/get/product-code'+`?name=${encodedValue}`)
            setProdcode(res.data);
        }catch(err){
            console.log(err);
        }
    }

    const Submit = async () => {
        setLoad(true);
        try{
            const res = await axios.post(orders_uri+'/create', {product_code: selectedItems1, phone_or_depo: datas.depo_and_phone, product_name: selectedItems, too: datas.too, leasing: datas.leasing, price_id: datas.price_id});
            if(res.status === 209){
                setLoad(false);
                return toast.error("Ийм утасны дугаар эсвэл дансны дугаартай харилцагч байхгүй байна !")
            }
            if(res.status === 201){
                setLoad(false);
                setDatas({...datas, code:'', depo_and_phone:'', too:''});
                return toast.success("Амжилттай")
            }
            setLoad(false);
        }catch(err){
            setLoad(false);
            return toast.success("Алдаа гарлаа !")
        }
    }

    useEffect(() => {
      Get();
    }, []);

    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const onChange = (value) => {
        setSelectedItems1('');
        setSelectedItems(value);
        GetProductCode(value);
        const b = data.find((it) => it.name === value);
        if(b.price_many === PRICE_TYPE.Y){
            GetPrices(b.id);
        }
    };

    const onChangePrice = (value) => {
        setDatas({...datas, price_id: value});
    };

    const onSearch = (value) => {
        console.log('search:');
    };

    const filterOption1 = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const onChange1 = (value) => {
        setSelectedItems1(value);
        console.log(`selected ${value}`);
    };

    const onSearch1 = (value) => {
        console.log('search:', value);
    };

    const handleLeasingChange = (e) => {
        const { checked } = e.target;
        setDatas({ ...datas, leasing: checked ? LEASING_TYPES.Y : LEASING_TYPES.N });
    };

  return (
    <div>
        <h1 className='cursor-pointer' onClick={nav}>{'<'} Буцах</h1>
        <div className='mt-4'>
            <div className='bg-white p-4 rounded-md'>
                <h1 className='text-xl font-bold font-Roboto text-center'>Захиалга шивэх</h1>
                <div className='mt-8'>

                    <h1 className='text-sm font-bold'>Хэрэглэгчийн дансны дугаар эсвэл утасны дугаар</h1>
                    <Input value={datas.depo_and_phone} onChange={(e => setDatas({...datas, depo_and_phone:e.target.value}))} type='number' className='mt-2' size='' placeholder='Дансны дугаар эсвэл утасны дугаар'/>
                    
                    <h1 className='text-sm font-bold mt-4'>Захиалсан бараа сонгох</h1>
                    <Select
                        className='w-full mt-2'
                        showSearch
                        placeholder="Бараа сонгох"
                        optionFilterProp="children"
                        onChange={onChange}
                        onSearch={onSearch}
                        filterOption={filterOption}
                        options={data.map((product) => ({
                            value: product.name,
                            label: product.name + "" + `(${product.price})`,
                        }))}
                    />

                    {
                        prodcode.length > 0 &&
                        <>
                            <h1 className='text-sm font-bold mt-2'>Барааны код оруулах</h1>
                            <Select
                                className='w-full mt-2'
                                showSearch
                                placeholder="Барааны код сонгох"
                                optionFilterProp="children"
                                onChange={onChange1}
                                onSearch={onSearch1}
                                filterOption={filterOption1}
                                options={prodcode.map((product) => ({
                                    value: product.code,
                                    label: product.code,
                                }))}
                            />
                        </>
                    }

                    <h1 className='text-sm font-bold mt-2'>Тоо ширхэг</h1>
                    <Input value={datas.too} onChange={(e => setDatas({...datas, too:e.target.value}))} type='number' className='mt-2' size='' placeholder='Тоо ширхэг оруулах'/>

                    {
                        price.length > 0 &&
                        <>
                            <h1 className='text-sm font-bold mt-4'>Үнэ сонгох</h1>
                            <Select
                                className='w-full mt-2'
                                showSearch
                                placeholder="Үнэ сонгох"
                                optionFilterProp="children"
                                onChange={onChangePrice}
                                filterOption={filterOption}
                                options={price.map((product) => ({
                                    value: product.id,
                                    label: product.price,
                                }))}
                            />
                        </>
                    }

                    <Checkbox className='mt-4' checked={datas.leasing === LEASING_TYPES.Y} onChange={handleLeasingChange}>
                        Лизингтэй эсэх
                    </Checkbox>

                    <div className='flex justify-end'>
                        {
                            load?
                            <Button className='bg-green-200  my-8 text-gray-400'>Хадгалж байна ...</Button>
                            :
                            <Button className='bg-green-600 text-white my-8' onClick={Submit}>Захиалга үүсгэх</Button>
                        }
                    </div>

                </div>
            </div>
        </div>
    </div>
  )
}

export default OrderCreate
